import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Caption1, formatCurrency, Tooltip } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { getCurrencyCodeByProjectId, getFormatCurrencyArgs } from "~/store/selectors/selector.currencies";
import { FormatSmartAbsoluteDate } from "../Formatters/FormatSmartAbsoluteDate";

export const GroupHeader = ({ date, total, projectId, className }) => {
  const { t } = useTranslation();

  const currencyCode = useSelector((state) => getCurrencyCodeByProjectId(state, projectId));
  const formatterArgs = useSelector((state) => getFormatCurrencyArgs(state, currencyCode));

  return (
    <div className={classNames("tw-flex", className)}>
      <Caption1 weight="bold">
        <FormatSmartAbsoluteDate date={date} />
      </Caption1>
      <Caption1
        color="secondary"
        weight="medium"
        className="tw-mx-1"
      >
        /
      </Caption1>
      <Tooltip
        title={formatCurrency(
          total,
          formatterArgs.thousand_separator,
          formatterArgs.decimal_separator,
          false,
          formatterArgs.decimal_spaces,
          "long",
          formatterArgs.code
        )}
      >
        <Caption1
          color="secondary"
          weight="medium"
          tabularNums
        >
          {t("Total")}:{" "}
          {formatCurrency(
            total,
            formatterArgs.thousand_separator,
            formatterArgs.decimal_separator,
            true,
            formatterArgs.decimal_spaces,
            "short",
            formatterArgs.code
          )}
        </Caption1>
      </Tooltip>
    </div>
  );
};

GroupHeader.propTypes = {
  date: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
  className: PropTypes.string,
};
